import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';

@Injectable({
  providedIn: 'root',
})
export class AlertNotificationService {

  constructor(private apiService: ApiService) { }

  getAlertInfo(patientId) {
    return this.apiService.get(ClinicianApiEndPointConstants.alertInfo(patientId));
  }  

  
  updateAlertInfo(id, info) {
    return this.apiService.put(ClinicianApiEndPointConstants.alertInfo(id), info);
  }
}
